/**
 * Item Type Constants
 * Shared constants for menu item types
 */

export const ITEM_TYPES = {
  SIMPLE: 'SIMPLE',
  COMBO: 'COMBO',
  PERSONALIZED: 'PERSONALIZED'
};

/**
 * Validates if an item type value is valid
 */
export const isValidItemType = (type) => {
  return Object.values(ITEM_TYPES).includes(type);
};

/**
 * Get item type or default to SIMPLE for backwards compatibility.
 * Falls back to structural detection for items that pre-date the itemType field.
 */
export const getItemType = (item) => {
  if (item && item.itemType && isValidItemType(item.itemType)) {
    return item.itemType;
  }
  // Structural detection for legacy items missing the itemType field
  if (item && (item.personalizedFlavorConfig || item.personalizedConfig || item.personalizedSelections?.flavors?.length > 0)) {
    return ITEM_TYPES.PERSONALIZED;
  }
  if (item && item.comboSlots?.length > 0) {
    return ITEM_TYPES.COMBO;
  }
  return ITEM_TYPES.SIMPLE;
};
